/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  PhoneCallbackRequest,
  PhoneStatusResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Where the UI hands back what Microsoft's sign-in redirect carried.
 *
 * A POST BODY, NOT A QUERY STRING: `id_token` is a bearer-grade credential for the
 * sign-in and a URL ends up in access logs, proxies and browser history.
 *
 * `id_token` is the ONLY source of the tenant; `tenant` and `admin_consent` are
 * accepted for the local mock flow and ignored otherwise. Free-text error
 * descriptions are not accepted at all: they come from a third party and would be
 * stored and shown to the admin.
 * @summary Complete Phone Connection
 */
export const completePhoneConnection = (
    phoneCallbackRequest: PhoneCallbackRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<PhoneStatusResponse>(
      {url: `/phone/callback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: phoneCallbackRequest, signal
    },
      options);
    }




export const getCompletePhoneConnectionMutationKey = () => ['completePhoneConnection'] as const;

export const getCompletePhoneConnectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePhoneConnection>>, TError,CompletePhoneConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof completePhoneConnection>>, TError,CompletePhoneConnectionMutationVariables, TContext> => {

const mutationKey = getCompletePhoneConnectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePhoneConnection>>, CompletePhoneConnectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  completePhoneConnection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompletePhoneConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof completePhoneConnection>>>
    export type CompletePhoneConnectionMutationBody = PhoneCallbackRequest
    export type CompletePhoneConnectionMutationError = HTTPValidationError
    export type CompletePhoneConnectionMutationVariables = {data: PhoneCallbackRequest}

    /**
 * @summary Complete Phone Connection
 */
export const useCompletePhoneConnection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePhoneConnection>>, TError,CompletePhoneConnectionMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completePhoneConnection>>,
        TError,
        CompletePhoneConnectionMutationVariables,
        TContext
      > => {
      return useMutation(getCompletePhoneConnectionMutationOptions(options));
    }
